import { API_BASE } from '../constants';
import { getData } from '../_base';
import { getCurrentLanguageDto } from '../../utilitys/language';
import { AdsOfficeDto } from '../../dto/adsOffice';

const base = `${API_BASE}/v1/AdsOffice`;

const url = {
  getAllByLanguage: `${base}/GetAll`,
};

export const getAllAdsOfficeByLangApi = async (): Promise<AdsOfficeDto[]> => {
  const lngDto = getCurrentLanguageDto();
  const _url = `${url.getAllByLanguage}/${lngDto.id}`;
  const result = await getData<AdsOfficeDto[]>(_url);
  if (result && !result.hasError && result.data ) return result.data;
  else return [];
};
